import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { DropdownFilterContainer, StyledMenuItem, StyledSelect } from "../Atom"
import { SxProps, Typography } from "@mui/material"

type SingleSelectFilterProps = {
  disabled: boolean
  changeHandler: any
  placeHolder: string
  selectedValue: any
  filterData: Array<any>
  filterLabel: string
  width?: number
  containerStyles?: SxProps
}

const SingleSelectFilter = (props: SingleSelectFilterProps) => {
  const { disabled, changeHandler, placeHolder, filterData } = props
  const { selectedValue, filterLabel, width, containerStyles } = props

  return (
    <DropdownFilterContainer sx={containerStyles}>
      <Typography fontSize={10}>{filterLabel}</Typography>

      <StyledSelect
        value={selectedValue}
        onChange={changeHandler}
        disabled={disabled}
        IconComponent={ExpandMoreIcon}
        displayEmpty
        renderValue={(): any =>
          selectedValue ? `${selectedValue?.label}` : `${placeHolder}`
        }
        sx={{
          width,
        }}
      >
        {filterData?.length ? (
          filterData?.map((item: any, index: number) => (
            <StyledMenuItem
              key={`${item?.label}-${index}`}
              value={item}
              sx={{
                backgroundColor:
                  selectedValue?.label === item?.label
                    ? "#1976D214"
                    : "transparent",
                width: width ? width - 20 : "210px",
              }}
            >
              {item?.label}
            </StyledMenuItem>
          ))
        ) : (
          <StyledMenuItem
            disabled={true}
            sx={{ width: width ? width - 20 : "auto" }}
          >
            No Data
          </StyledMenuItem>
        )}
      </StyledSelect>
    </DropdownFilterContainer>
  )
}

export default SingleSelectFilter
